module.exports = __webpack_public_path__ + "img/logo1.75f03280.png";